<template>
  <div id="app">
    <img src="./assets/logo.png">
    <router-view/>
    <div class="copyright">
      <!-- Copyright © ebus.top All Rights Reserved. -->
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=45010002451330" rel="noreferrer" target="_blank">
        <img class="icon_beian" :src="icon_beian" />
        <span>桂公网安备45010002451330号</span>
      </a>
      <a href="https://beian.miit.gov.cn/" target="_blank">桂ICP备2026002824号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      icon_beian: require("./assets/beian.png")
    };
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.copyright {
  width: 100%;
  position: fixed;
  bottom: 5px;
  text-align: center;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
}

.icon_beian {
  height: 18px;
}

.copyright a {
  color: #324057;
  text-decoration: none;
  display: flex;
  gap: 4px;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue